export default {
  getCdnImage (imageUrl, type = 'zoom', width = 86, height = 129) {
    imageUrl = String(imageUrl);
    if ((imageUrl.search('cdn.dsmcdn.com') > -1 && imageUrl.search('spm-product-image') < 0) || imageUrl.search('s3.trendyol.com') > -1) {
      const ext = imageUrl.split('.').pop();
      imageUrl = imageUrl.search('_org_') < 0 ? imageUrl.replace(`.${ext}`, `_org_${type}.${ext}`) : imageUrl;
      return imageUrl.replace(/com\/\//gi, 'com/');
    } else if (imageUrl.search('aliyuncs.com') > -1) {
      if (imageUrl.search('style/resized') > -1) {
        const _imageUrl = imageUrl.split('style/resized')[0];
        imageUrl = `${_imageUrl}image/resize,w_${width},h_${height},limit_0`;
        return imageUrl.replace(/com\/\//gi, 'com/');
      } else if (imageUrl.search('image/resize') < 0) {
        imageUrl = `${imageUrl}?x-oss-process=image/resize,w_${width},h_${height},limit_0`;
        return imageUrl.replace(/com\/\//gi, 'com/');
      }
    }
    return imageUrl;
  },
  clearCdnImage (imageUrl) {
    if ((imageUrl.search('cdn.dsmcdn.com') > -1 && imageUrl.search('spm-product-image') < 0) || imageUrl.search('s3.trendyol.com') > -1) {
      if (imageUrl.search('_org_') > -1) {
        imageUrl = imageUrl.toString().replace(/_org_zoom/gi, '').replace(/_org_icon/gi, '');
      }
    } else if (imageUrl.search('aliyuncs.com') > -1) {
      const imageUrlParse = imageUrl.split('?');
      if (imageUrlParse.length > 1) {
        imageUrlParse.pop();
      }
      imageUrl = imageUrlParse.join('');
    }
    return imageUrl;
  },
};
